export default __webpack_public_path__ + "static/media/restaurant-2-lqMAX.e758e7b9.jpg";